module.exports = __webpack_public_path__ + "img/2).cfb42c23.png";